import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppLoader',
  setup() {
    return {}
  },
})
